import Cookies from 'universal-cookie';

const cookies = new Cookies();

/**
 * Returns true if client-visible session markers exist (same markers cleared on logout in RemoveCookies).
 * Used by AuthGuard so protected routes cannot show stale UI after logout + back/forward cache restore.
 */
export function hasInsightSession() {
  return Boolean(cookies.get('_Id') || cookies.get('accountId'));
}
